import React, { useEffect, useMemo, useCallback } from 'react';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { makeStyles } from '@material-ui/core/styles';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer';
import GridItem from '@/components/material-ui-kit/components/Grid/GridItem';
import Button from '@/components/material-ui-kit/components/CustomButtons/Button';
import Card from '@/components/material-ui-kit/components/Card/Card';
import CardBody from '@/components/material-ui-kit/components/Card/CardBody';
import CardFooter from '@/components/material-ui-kit/components/Card/CardFooter';
import image from 'public/img/contents/main-visual-login.jpg';
import Main from '@/layouts/Main';
import Head from '@/components/common/Head';
import styles from 'styles/jss/original/pages/logins';
import meta from '@/config/meta';
import classNames from 'classnames';
import _ from 'lodash';
import basicAuthentication from '@/lib/basicAuthentication';
import useUser from '@/hooks/useUser';
import { wrapper } from '@/store/configureStore';
import { callAuth as firebaseCallAuth } from '@/lib/firebase/auth';

// @ts-expect-error
const useStyles = makeStyles(styles);

const LoginsPage: NextPage = () => {
  const classes = useStyles();
  const router = useRouter();
  const user = useUser();
  useEffect(() => {
    if (user) {
      _.defer(() => router.replace('/'));
    }
  }, [router, user]);
  const texts = useMemo(
    () => ({
      title: 'ログイン',
      description: 'お手持ちのSNSアカウントを使ってログインください'
    }),
    []
  );
  const callAuth = useCallback((snsType) => {
    firebaseCallAuth(snsType);
  }, []);
  const buttonList = useMemo(
    () => [
      {
        color: 'facebook',
        icon: 'facebook-square',
        title: ' Sign in with Facebook',
        onClick: () => callAuth('facebook')
      },
      {
        color: 'twitter',
        icon: 'twitter',
        title: ' Sign in with Twitter',
        onClick: () => callAuth('twitter')
      },
      {
        color: 'google',
        icon: 'google-plus-square',
        title: ' Sign in with Google',
        onClick: () => callAuth('google')
      }
    ],
    [callAuth]
  );
  return (
    <div className={classes.page}>
      <Main>
        <Head
          title={meta.login.title}
          description={meta.login.description}
          image={meta.login.image}
          url={meta.login.url}
        />
        <div
          className={classes.pageHeader}
          style={{
            backgroundImage: 'url(' + image + ')',
            backgroundSize: 'cover',
            backgroundPosition: 'top center'
          }}
        >
          <div className={classes.container}>
            {/* @ts-expect-error */}
            <GridContainer justify='center'>
              {/* @ts-expect-error */}
              <GridItem xs={12} sm={10} md={10}>
                <Card className={classes.card}>
                  <CardBody signup>
                    <h1 className={classes.titleLevel3}>{texts.title}</h1>
                    <h5 className={classes.description}>{texts.description}</h5>
                  </CardBody>
                  <CardFooter className={classes.cardFooter}>
                    {buttonList.map((item) => {
                      return (
                        <div key={item.title}>
                          {/* @ts-expect-error */}
                          <Button
                            color={item.color}
                            className={classes.flexItem}
                            onClick={item.onClick}
                          >
                            <i className={classNames('fab', `fa-${item.icon}`)} />
                            {item.title}
                          </Button>
                        </div>
                      );
                    })}
                  </CardFooter>
                </Card>
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </Main>
    </div>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(async ({ req, res }) => {
  if (!process.browser) {
    basicAuthentication({ req, res });
  }
});

export default LoginsPage;
